import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
function getLegendUtilityClass(slot) {
  return generateUtilityClass('MuiChartsLegend', slot);
}
export const useUtilityClasses = props => {
  const {
    classes,
    direction
  } = props;
  const slots = {
    root: ['root', direction],
    item: ['item'],
    mark: ['mark'],
    label: ['label'],
    series: ['series']
  };
  return composeClasses(slots, getLegendUtilityClass, classes);
};
export const legendClasses = generateUtilityClasses('MuiChartsLegend', ['root', 'item', 'series', 'mark', 'label', 'vertical', 'horizontal']);